var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_56517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2643_56517)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_56517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.639 0H15.3398V54.0671H133.639V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_56517)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2643_56517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.639 0H15.3398V54.0671H133.639V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2643_56517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0762 16.8955V29.3673C44.0762 34.0638 47.3513 37.1679 51.6226 37.1679C53.7005 37.1679 55.5518 36.373 56.8901 34.9794V36.8308H59.8483V16.8955H56.8599V29.1913C56.8599 32.3533 54.7217 34.4889 51.9622 34.4889C49.17 34.4889 47.067 32.4086 47.067 29.1913V16.898H44.0762V16.8955ZM62.7914 16.8955V36.8308H65.6339V35.0071C66.9445 36.3454 68.7959 37.1704 70.8158 37.1704C71.8155 37.1797 72.8073 36.9907 73.7334 36.6141C74.6597 36.2377 75.502 35.6813 76.2118 34.9772C76.9216 34.273 77.4847 33.4351 77.8685 32.5119C78.2522 31.5887 78.4492 30.5986 78.4478 29.5988C78.4524 28.5966 78.2582 27.6034 77.8761 26.677C77.4941 25.7505 76.9319 24.9091 76.2223 24.2015C75.5126 23.4939 74.6694 22.9342 73.7418 22.5549C72.8142 22.1756 71.8204 21.9843 70.8184 21.9919C69.8581 21.9907 68.9074 22.1817 68.0222 22.5537C67.137 22.9256 66.3352 23.471 65.664 24.1578V16.898H62.7888L62.7914 16.8955ZM87.6168 22.0222C83.3731 22.0222 80.1583 25.4683 80.1583 29.5685C80.1583 33.8953 83.514 37.1402 87.8708 37.1402C90.5196 37.1402 92.6829 35.9755 94.1343 34.0386L92.0566 32.5016C90.9749 33.953 89.5512 34.6322 87.8708 34.6322C85.4232 34.6322 83.4611 32.8714 83.0612 30.5068H94.8764V29.5685C94.8764 25.2419 91.8025 22.0222 87.6168 22.0222ZM103.452 22.1932C101.857 22.1932 100.69 22.9327 99.9781 24.0999V22.3064H97.1328V36.8308H100.005V28.5674C100.005 26.3186 101.374 24.8697 103.253 24.8697H104.448V22.1907H103.452V22.1932ZM87.5563 24.5276C89.6945 24.5276 91.4906 26.0066 91.9735 28.2253H83.1166C83.6272 26.0066 85.4207 24.5276 87.5563 24.5276ZM70.6221 24.5577C73.3539 24.5577 75.6027 26.7789 75.6027 29.5988C75.6081 30.9262 75.0868 32.2016 74.1531 33.1453C73.2193 34.0889 71.9495 34.6236 70.6221 34.6322C69.9616 34.6336 69.3075 34.5042 68.6973 34.2514C68.0871 33.9988 67.5331 33.6277 67.067 33.1598C66.601 32.6919 66.2321 32.1362 65.9819 31.525C65.7316 30.9139 65.6047 30.2592 65.6087 29.5988C65.6041 28.938 65.7303 28.2828 65.9801 27.6712C66.2299 27.0594 66.5983 26.5032 67.0642 26.0346C67.53 25.5659 68.084 25.1941 68.6942 24.9406C69.3045 24.6872 69.9588 24.557 70.6195 24.5577H70.6221Z",
    fill: "#172342",
    fillOpacity: 0.6
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_56517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.324219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2643_56517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.324219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg7);
export default __webpack_public_path__ + "static/media/img7.931f5f051753e5120af60a5dd9a763a6.svg";
export { ForwardRef as ReactComponent };